import { Dropdown, MenuProps } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { LogOut } from "../../../features/AuthenticateView/pages/Login/Login.types";
import { REFRESH_TOKEN_KEY, TOKEN_KEY } from "../../utils/SessionConstants";
import { LogoutService } from "../../../features/AuthenticateView/services/LoginService";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

import navStyle from "./Navbar.module.css";
import { useState } from "react";
import { SESSION_USERNAME } from "../../utils/CommonConstants";

export const UserProfile = () => {
  const [username, setUsername] = useState<string>(
    localStorage.getItem(SESSION_USERNAME) ?? ""
  );
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    if (accounts.length > 0) {
      // Signed in via Azure AD — MSAL owns the session teardown
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin + "/",
      });
      return;
    }

    let logOut: LogOut = {
      token: localStorage.getItem(TOKEN_KEY),
      refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY),
      isConsentAccepted: null,
    };
    LogoutService(logOut);
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
    setUsername("");
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: username,
      disabled: true,
    },
    {
      key: "2",
      label: "Log out",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <div className={navStyle.userDropdown}>
        <UserOutlined />
      </div>
    </Dropdown>
  );
};
